module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec14"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" the "), _c('em', [_vm._v("Mrs. Dalloway")]), _vm._v(" series")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec15"
    }
  }), _vm._v("Opened and Shut")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("She had prepared a looking-glass: hair, dress, thought,"), _c('br'), _vm._v("sofa in the glow of dogs barking.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Beautifully close up. And once, flames"), _c('br'), _vm._v("eating the edge of the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Her eyelashes blurred. Chin, nose, forehead, some lips."), _c('br'), _vm._v("The cheek. The glass looking first at one thing,"), _c('br'), _vm._v("then another: nose, eyes, evening.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("She sat looking at the map of her hands."), _c('br'), _vm._v("The window, the clock, her pulse.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The body was busy thinking, conjuring"), _c('br'), _vm._v("the museum of a moment: emotion, scenes, people,"), _c('br'), _vm._v("bags of treasures. Heaps of theories.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Theories to explain feeling the here and the back of the hand."), _c('br'), _vm._v("A theory allowed one thing after another."), _c('br'), _vm._v("First, dinner, then morning.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Her hand was the world."), _c('br'), _vm._v("To get to it she had to look at herself.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To get at the truth one would have to disregard"), _c('br'), _vm._v("anything false. Yet the truth was intangible.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("One eye on the horizon: a long indeterminable,"), _c('br'), _vm._v("mere straightness, a few plants."), _c('br'), _vm._v("That indescribable purple.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Doors being opened. Visual impressions—"), _c('br'), _vm._v("as if the eye were the brain, the body entering the house.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8a7068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_i.vue
// module id = 111
// module chunks = 0